import type {ReactNode} from "react";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "@/components/ui/tabs";
import {cn} from "@/lib/utils";

type Props = {
  ro: ReactNode;
  en: ReactNode;
  className?: string;
};

export function AdminLangTabs({ro, en, className}: Props) {
  return (
    <Tabs defaultValue="ro" className={cn("admin-lang-tabs", className)}>
      <TabsList className="mb-4 grid w-full max-w-xs grid-cols-2">
        <TabsTrigger value="ro">Romanian</TabsTrigger>
        <TabsTrigger value="en">English</TabsTrigger>
      </TabsList>
      <TabsContent value="ro" className="space-y-4">{ro}</TabsContent>
      <TabsContent value="en" className="space-y-4">{en}</TabsContent>
    </Tabs>
  );
}
